// src/pages/Integrations/innerComponnent/ConfirmConnectModal.tsx
import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  Spinner
} from 'reactstrap';
import SvgIcon from './SvgIcon';

interface ConfirmConnectModalProps {
  show: boolean;
  onCloseClick: () => void;
  onConfirm: () => void;
  loading?: boolean;            // <-- added
  selectedPlatform: {
    app: {
      name: string;
      logo_url: string;
    };
    config: any;
  };
}

const ConfirmConnectModal: React.FC<ConfirmConnectModalProps> = ({
  show, onCloseClick, onConfirm, loading = false, selectedPlatform
}) => {
  const { app } = selectedPlatform;

  return (
    <Modal isOpen={show} centered backdrop="static" size="md" style={{ maxWidth: 500 }}>
      <ModalHeader toggle={onCloseClick} className="bg-light text-white border-0 py-4 px-4">
        <div className="d-flex align-items-center">
          <div className="bg-white rounded-circle d-flex align-items-center justify-content-center"
               style={{ width: 50, height: 50 }}>
            <SvgIcon src={app.logo_url} />
          </div>
          <div className="ms-3">
            <h4 className="mb-1">Connect {app.name}</h4>
            <small>Secure OAuth 2.0 authentication</small>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="px-4 py-3">
        <p className="lead mb-3 text-secondary">
          Grant CRM access to your <strong>{app.name}</strong> account so we can:
        </p>
        <ListGroup flush className="mb-3">
          <ListGroupItem className="d-flex align-items-center px-0 mb-2 border-0">
            <i className="ri-checkbox-circle-fill text-success fs-5 me-3" />
            <div>
              <div className="fw-semibold">Import leads automatically</div>
              <small className="text-muted">Never miss a new contact</small>
            </div>
          </ListGroupItem>
          <ListGroupItem className="d-flex align-items-center px-0 mb-2 border-0">
            <i className="ri-bar-chart-2-fill text-info fs-5 me-3" />
            <div>
              <div className="fw-semibold">View performance insights</div>
              <small className="text-muted">Key metrics at a glance</small>
            </div>
          </ListGroupItem>
          <ListGroupItem className="d-flex align-items-center px-0 border-0">
            <i className="ri-refresh-line text-warning fs-5 me-3" />
            <div>
              <div className="fw-semibold">Sync every 15 minutes</div>
              <small className="text-muted">Always up-to-date data</small>
            </div>
          </ListGroupItem>
        </ListGroup>
        <small className="text-muted d-block">
          We’ll never post on your behalf. You can revoke access at any time.
        </small>
      </ModalBody>

      <ModalFooter className="border-0 px-4 pb-4">
        <Button color="light" outline size="md" onClick={onCloseClick} className="me-2">
          Cancel
        </Button>
        <Button color="primary" size="md" onClick={onConfirm} disabled={loading}>
          {loading
            ? <Spinner size="sm" />
            : "Connect"
          }
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmConnectModal;
